import React from "react";
import logo from "../assets/registerImages/pmk-logo.svg";
import { withTranslation } from "react-i18next";
import appStoreIcon from "../assets/commonImages/appStoreIcon.png";
import googlePlayIcon from "../assets/commonImages/googlePlayIcon.png";
class RegisterHeader extends React.Component {
  render() {
    return (
      <div className="col-sm-12 col-md-7 col-lg-7 col-xl-8 main-col">
        <div className="pmk-landing">
          <div className="logo-wrapper">
            <a className="navbar-brand" href="/">
              <img src={logo} alt="PikMyKid" title="PikMyKid" />
            </a>
          </div>
          <div className="welcome-sect">
            <div className="title-sect">
              <h1 className="title-1">
                {this.props.t("landingScreen-welcome-to")} Pikmykid!
              </h1>
            </div>
          </div>
          <div className="appdownload-sect">
            <div className="appdownload-wrapper">
              <p>
                Our apps are available in App store and Google playstore for
                download
              </p>
              <div className="appdownload-icons">
                <a
                  className="store-icon google-play"
                  href="https://play.google.com/store/apps/details?id=com.pikmykid.parentapp&hl=en_IN&gl=US"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src={googlePlayIcon}
                    alt="Google play"
                    title="Google play"
                  />
                </a>
                <a
                  className="store-icon appstore"
                  href="https://apps.apple.com/us/app/pikmykid-parent/id1559538995"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={appStoreIcon} alt="App Store" title="App Store" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withTranslation()(RegisterHeader);
